module.exports = __webpack_public_path__ + "static/media/news_2.bf3a64d5.jpg";